const PlanDDForm = (function ($) {
    const pddf = {
        Elements: {
            form: "form.vds-dropdown__selector",
            radioButton: "input[name='selectedProgram']",
            loadingSpinner: ".vds-loading-spinner"
        },
        BindEvents: function () {
            $(pddf.Elements.radioButton).on("change",
                function () {
                    $(pddf.Elements.loadingSpinner).show();
                    $(pddf.Elements.form).submit();
                });
        }
    };

    return {
        Init: pddf.BindEvents
    };
})(jQuery);

$('document').ready(function () {
    PlanDDForm.Init();
});
